<template>
  <v-row v-if="lodash.isEmpty(therapies)" justify="center">
    <v-col cols="6">
      <v-alert color="orange" outlined text type="info">
        Sem terapêuticas
      </v-alert>
    </v-col>
  </v-row>

  <v-row v-else>
    <TherapyListItem
      v-for="therapy in therapies"
      :key="therapy.id"
      :therapy="therapy"
      :attendance="attendance"
      :allowEdit="allowEdit"
      :allowDelete="allowDelete"
    />
  </v-row>
</template>

<script>
  import TherapyListItem from "@/components/attendance_therapy/list/item.vue";

  export default {
    name: "AttemdamceTherapyList",
    props: {
      attendance: Object,
      allowEdit: {
        type: Boolean,
        default: true,
      },
      allowDelete: {
        type: Boolean,
        default: true,
      },
      onlyDilation: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      TherapyListItem,
    },
    computed: {
      therapies() {
        if (this.onlyDilation) {
          return this.lodash.filter(this.attendance.therapies, "dilation");
        }

        return this.attendance.therapies;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
